export { html as en } from './en.md'
export { html as fr } from './fr.md'
